module.exports = __webpack_public_path__ + "img/left_top_4.fb8f532.png";